import React from "react";
import { Stack } from "@mui/material";
import {
  FoundationColorTokens,
  Spacing,
  Typography as LeoTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import { Check } from "lucide-react";
import { ICON_SIZE, getIconProps } from "@pulse/shared-components";
import { NestedTypographyComponent } from "../NestedTypographyComponent";
import { t } from "i18next";

interface DeleteColumnDialogSuccessProps {
  spacing: Spacing;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  respondentsAssigned: number | null;
}

export const AssignRespondentsToSpocsDialogSuccess = observer(
  ({
    spacing,
    tokens,
    typography,
    respondentsAssigned,
  }: DeleteColumnDialogSuccessProps): React.ReactElement => {
    return (
      <Stack
        gap={spacing.spaceXS}
        padding={spacing.spaceXL}
        direction="column"
        alignItems="center"
        textAlign="center"
      >
        <Check {...getIconProps(tokens.iconSuccess, ICON_SIZE.large)} />
        <NestedTypographyComponent
          textColor={tokens.labelSuccess}
          startText={undefined}
          middleBoldText={
            respondentsAssigned ? respondentsAssigned.toString() : undefined
          }
          endText={t(
            "projects.assignSpocsToRespondents.spocAssignSuccessDescription",
          )}
          startAndEndTextTypography={typography.b1}
          boldTextTypography={typography.s1}
          isSpan={false}
        />
      </Stack>
    );
  },
);
